<template>
  <div>
    <Header ref="header">
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      {{ headerTitle }}
    </Header>
    <div
      v-if="information"
      class="information d-flex flex-column"
      data-testid="information"
    >
      <div class="title">
        <div class="text-size-16 text-weight-500" data-testid="title">
          {{ information.title }}
        </div>

        <div
          class="updated-at text-size-14 text-mild text-weight-500 mt-2"
          data-testid="date"
        >
          {{ informationUpdatedAt }}
        </div>
      </div>

      <div class="text flex-grow-1 mt-2" data-testid="text">
        <p class="text-size-14" v-html="linkifyText(information.text)"></p>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { informationService } from "@/app/services/InformationService";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import { Information } from "@/types/message/Information";
import { formatFromISOString } from "@/utils/date";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import { linkifyText } from "@/utils/stringUtil";
import { Component, Vue } from "vue-facing-decorator";

@Component({
  components: {
    FeatherIcon,
    Header
  }
})
export default class InformationDetail extends Vue {
  information: Information | null = null;

  get headerTitle() {
    return process.env.VUE_APP_SERVICE_NAME_KANA + "運営事務局";
  }
  get informationUpdatedAt() {
    return formatFromISOString(this.information!.updatedAt);
  }
  async mounted() {
    try {
      this.$loading.show();
      const informationId = Number(this.$route.params.informationId);
      await Promise.all([
        this.fetchInformation(informationId),
        informationService.markAsRead(informationId)
      ]);
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }
  async fetchInformation(informationId: number) {
    this.information = await informationService.fetchInformation(informationId);
  }
  onClickBack() {
    this.$router.back();
  }
  linkifyText(text: string): string {
    return linkifyText(text);
  }
}
</script>
<style lang="scss" scoped>
.information {
  height: 90vh;
  margin: 10px;

  .title {
    padding: 12px;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 4px;

    .updated-at {
      text-align: right;
    }
  }

  .text {
    padding: 20px;
    word-wrap: break-word;
    white-space: pre-wrap;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 4px;

    :deep(a) {
      color: $blue;
      text-decoration: underline;
    }
  }
}
</style>
